import { ChevronsUpDown, Send, Trash2, ClipboardPlus, Printer, CloudDownload, Loader, EllipsisVertical, MailCheck, MessageSquareText, Repeat2, Stethoscope, Phone, LoaderCircle, Check, Copy, CircleCheck, UserCheck, MonitorCheck } from "lucide-react";
import React, { useEffect, useState } from "react";
import DeleteModal from "../Modal/DeleteModal";
import ReviewMessageModal from "../Modal/ReviewMessageModal";
import PatientSingleViewModal from "../Modal/PatientSingleViewModal";
import { all_insurance_options, calculateAgeFromDOB, can_visit, exchangeDate, formatTo12HourDateTime, isMobileDevice, notify, setSecureData } from "../../helpers";
import { sendWaitingRoomMails } from "../../services/patient";
import OtpConfirmationModal from "../Modal/OtpConfirmationModal";
import { Link } from "react-router-dom";
import CallNoteCallModal from "../Modal/CallNoteCallModal";
import CallNoteModal from "../Modal/CallNoteModal";
import CreateOrderModal from "../Modal/CreateOrderModal";
import LetterModal from "../Modal/LetterModal";
import MessageModal from "../Modal/MessageModal";
import AuditReportViewModal from "../Modal/AuditReportViewModal";
import { setPendingQmData } from "../../Session";
import Skeleton from "react-loading-skeleton";
import EligibilitySingleViewModal from "../Modal/EligibilitySingleViewModal";
import ClaimSingleViewModal from "../Modal/ClaimSingleViewModal";
const maleAvatar = './images/avatar.png';
const femaleAvatar = './images/female.png';
const otherAvatar = './images/other.png';

const styles = {
  display: "flex",
  alignItems: "center",
  gap: "5px",
  cursor: "pointer",
};

export default function WaitingRoomDataTable(props) {
  const {
    tableData = [],
    handleCheckboxChange = () => {},
    handleSendReviewRequest = () => {},
    handleSelectAll = () => {},
    handleDeleteRecord = () => {},
    handleSignOutSheet = () => {},
    downloadSignOutSheet = () => {},
    messageTemplate = [],
    reloadData = () => {},
    reloadDataFilter = {},
    account_id,
    location_id,
    setSmsLimit = () => {},
    dataLoading,
    setDataLoading = () => {},
    checkSelected = false,
    downloadBulkData = () => {},
    buttonLoader = false,
    checkedIds = [],
    setCheckedIds = () => {},
    globalCheckedIds,
    setGlobalCheckedIds,
    smsLimit,
    setLetterLimit = () => {},
    handleReferralNavigation = () => {},
    user_id = null,
    specilityId = null,
    showPrevisitLoaderData = {},
    copyCodesData = () => {},
    waitingRoomBulkDelete = false,
    setWaitingRoomBulkDelete = () => {},
    previousScrollPosition = 0,
    setPreviousScrollPosition = () => {},
    selectedProvider = null,
    checkBulkEligibility = () => {},
    eligibilityCheckLoader = false,
    checkBulkClaims = () => {},
    claimsCheckLoader = false
  } = props;

  const [viewStatusOptions, setViewStatusOptions] = useState({});
  const [insuranceOptions] = useState(all_insurance_options());
  const [activePatientViewModal, setActivePatientViewModal] = useState(false);  
  const [patientData, setPatientData] = useState({});
  const [orderBy, setOrderBy] = useState();
  const [activeModal, setActiveModal] = useState(false);
  const [activeMessageModal, setActiveMessageModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [isRed, setIsRed] = useState(false);
  const [isRedId, setIsRedId] = useState('');
  const [deleteRecord, setDeleteRecord] = useState({});
  const [activeDeleteModal, setActiveDeleteModal] = useState(false);
  const [sendMailButtonLoader, setSendMailButtonLoader] = useState(false);
  const [sendMailConfirmationModal, setSendMailConfirmationModal] = useState(false);
  const [activeLetterModal, setactiveLetterModal] = useState(false);
  const [activeCreateOrderModal, setActiveOrderModal] = useState(false);
  const [activeCallNoteModal, setActiveCallNoteModal] = useState(false);
  const [activeCallNoteCallModal, setActiveCallNoteCallModal] = useState(false);
  const [callNoteCallType, setCallNoteCallType] = useState('');
  const [callId, setCallId] = useState(null);
  const [outreachOpen, setOutreachOpen] = useState(false);
  const [startSchedular, setStartSchedular] = useState(false);
  const [previsitViewStatus, setPrevisitViewStatus] = useState(false);
  const [viewPreVisitcallId, setViewPreVisitcallId] = useState(null);
  const [previousCallScrollPosition, setPreviousCallScrollPosition] = useState(0);  
  const [deviceType, setDeviceType] = useState('');
  const [postVisitLoaderId, setPostVisitLoaderId] = useState(null);
  const [enablePostVisitLoader, setEnablePostVisitLoader] = useState(false);
  const [postVisitCheckId, setPostVisitCheckId] = useState([]);
  const [postVisitUploadEmrId, setPostVisitUploadEmrId] = useState(null);
  const [uploadEmrIds, setUploadEmrIds] = useState([]);
  const [activeEligibilityViewModal, setActiveEligibilityViewModal] = useState(false); 
  const [activeClaimViewModal, setActiveClaimViewModal] = useState(false); 

  async function handleCheckEligibilityRow(data) {
    setPatientData(data);
    setActiveEligibilityViewModal(!activeEligibilityViewModal);
    setPreviousScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
  }

  async function handleCheckClaimRow(data) {
    setPatientData(data);
    setActiveClaimViewModal(!activeClaimViewModal);
    setPreviousScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
  }

  useEffect(() => {
    const UserDeviceType = isMobileDevice() ? 'mobile' : 'desktop';
    setDeviceType(UserDeviceType);
  }, []);

  useEffect(() => {
    if (postVisitLoaderId) {
      setPostVisitCheckId((prev) => {
        const updatedArray = [...prev, postVisitLoaderId];
        return [...new Set(updatedArray)]; // Remove duplicates
      });
    }
  }, [postVisitLoaderId]);

  useEffect(() => {
    if (postVisitUploadEmrId) {
      setUploadEmrIds((prev) => {
        const updatedArray = [...prev, postVisitUploadEmrId];
        return [...new Set(updatedArray)];
      });
    }
  }, [postVisitUploadEmrId]);

  const onCloseModal = () => {
    setActiveModal(false);
    setSelectedItem({});
  };  
  
  const handleOrderChange = (name, type = "asc") => {
    name = name.toString();
    setOrderBy(name);
    if (reloadDataFilter.order_by && reloadDataFilter.order_by[0] == name) {
      if (reloadDataFilter.order_by[1] == "asc") {
        type = "desc";
      }
    }
    const orderFilter = { order_by: [name, type.toString()] };
    const filter_merge = { ...reloadDataFilter, ...orderFilter };
    reloadData(filter_merge);
    setDataLoading(true);
  };

  const handleClick = (item) => {
    setIsRed(true);
    setIsRedId(item.id);
    handleSignOutSheet(item.patientId, item.id, exchangeDate(item.dos));
  };

  const handleSendMessageModal = (data) => {
    setPatientData(data);
    setActiveMessageModal(!activeMessageModal);
    setPreviousScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
  }

  const handleLetterModal = (data) => {
    setPatientData(data);
    setactiveLetterModal(!activeLetterModal);
    setPreviousScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
  }

  const handleCallNoteModal = (data) => {
    setPatientData(data);
    setActiveCallNoteModal(!activeCallNoteModal);
    setPreviousScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
  }

  const handleCreateOrderModal = (data) => {
    setPatientData(data);
    setActiveOrderModal(!activeCreateOrderModal);
    setPreviousScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
  }

  const handleOutsideClick = (event) => {
    if (!event.target.closest(".dropdown-container")) {
      setViewStatusOptions({});
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  const handleDropdownClick = (index) => {
    setViewStatusOptions((prev) => {
      const newViewStatusOptions = {};
      newViewStatusOptions[index] = !prev[index];
      return newViewStatusOptions;
    });
  };

  const handleSendEmail = async () => {
    const data = {
      account_id: account_id,
      location_id: location_id,
      selected_ids: Array.from(globalCheckedIds),
      type: "email",
      speciality_id: reloadDataFilter?.speciality_id,
      provider_id: reloadDataFilter?.provider_id
    };
    setSendMailButtonLoader(true);

    try {
      const response = await sendWaitingRoomMails(data);
      if(response){
        if(response?.detail) {
          notify("error", response?.detail, 2);
        } else {
          if( response?.data?.status === "success"){
            notify("success", response?.data?.message, 2);
            setSendMailConfirmationModal(false);
            window.scrollTo(0, previousScrollPosition);
            setGlobalCheckedIds(new Set());
          } else {
            notify("error", response?.data?.message, 2);
          }
        }
      }
    } catch (error) {
      if (error?.response && error?.response?.data && error?.response?.data?.detail) {
        notify("error", error?.response?.data?.detail, 0.5);
      }
    } finally {
      setSendMailButtonLoader(false);
    }
  };

  const handleReportNavigation = async () => {
    const _ = {
      account_id: account_id,
      location_id: location_id,
      selected_ids: Array.from(globalCheckedIds),
      type: "print",
      speciality_id: reloadDataFilter?.speciality_id,
      provider_id: reloadDataFilter?.provider_id,
      selected_provider: selectedProvider,
    };
    await setSecureData(
      "pending_qm_data",
      JSON.stringify(_)      
    );  
    setPendingQmData(_)

    window.open(`/summary-report`, '_blank', 'noopener,noreferrer');
  };

  const removeSelection = () => {
    setCheckedIds([]);
    setGlobalCheckedIds(new Set());
  };

  const handleDelete = (item) => {
    setDeleteRecord(item);
    setActiveDeleteModal(true);
    setPreviousScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
  }

  const handleDownloadSheet = (item) => {
    downloadSignOutSheet(
      item.patientId,
      item.id,
      exchangeDate(item.dos)
    )
  }

  const handleViewPreVisit = (item) => {
    if (item.status === "deleted") {
      return;
    }
    setPrevisitViewStatus(true);
    setPreviousScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
    setViewPreVisitcallId(item.id);
    setPatientData(item);
  };

  const handleCopyCodes = (item) => {
    copyCodesData(reloadDataFilter, item?.id);
  };

  const buttonArray = [
    { label: 'Check Eligibility', icon: UserCheck, isButton: true, action: handleCheckEligibilityRow },
    { label: 'Check Claim', icon: MonitorCheck, isButton: true, action: handleCheckClaimRow },
    { label: 'Print Pre-visit planning', icon: Printer, isButton: true, action: handleClick },
    { label: 'Copy codes', icon: Copy, isButton: true, action: handleCopyCodes },
    { label: 'Add call note', icon: Phone, isButton: true, action: handleCallNoteModal },
    // { label: 'Create AI chart', icon: ClipboardPlus, isButton: false, action: '/ai-charting/create' },
    { label: 'Create order', icon: Stethoscope, isButton: true, action: handleCreateOrderModal },
    { label: 'Refer patient', icon: Repeat2, isButton: true, action: handleReferralNavigation },
    { label: 'Send letter', icon: Send, isButton: true, action: handleLetterModal },
    { label: 'Send message', icon: MessageSquareText, isButton: true, action: handleSendMessageModal },
    { label: 'Download Pre-visit planning', icon: CloudDownload, isButton: true, action: handleDownloadSheet },
    { label: 'Delete', icon: Trash2, isButton: true, action: handleDelete },
  ];
  const permissions = {
    showButton1: can_visit('eligibility'),
    showButton2: can_visit('eligibility'),
    showButton3: can_visit('waiting_room'),
    showButton4: can_visit('waiting_room_copy_codes'),
    showButton5: can_visit('_call_note'),
    // showButton3: can_visit('ai_charting') && can_visit('ai_charting_create'),
    showButton6: can_visit('imaging_orders') && can_visit('imaging_orders_create'),
    showButton7: can_visit('easy_referral') && can_visit('easy_referral_create'),
    showButton8: can_visit('letter') && can_visit('_send_letter'),
    showButton9: can_visit('_single_message'),
    showButton10: can_visit('waiting_room'),
    showButton11: can_visit('waiting_room') && can_visit('waiting_room_delete'),
  };

  return (
    <>
      {checkSelected && (
        <>
          <hr />
          <div className="docpro_data_table_btns">
            {(can_visit('waiting_room') && can_visit('waiting_room_delete')) && (
              <button className="docpro_bordered_btn docpro_fw_600 docpro_red_color"
                onClick={() => {
                  setWaitingRoomBulkDelete(!waitingRoomBulkDelete);
                  setPreviousScrollPosition(window.scrollY);
                  window.scrollTo(0, 0);
                }}
              >
                <Trash2 width={20} height={20} />
                Delete
              </button>
            )}

            {can_visit('eligibility') && (
              <button className="docpro_bordered_btn docpro_fw_600"
                onClick={() => { checkBulkEligibility(); }}
              >
                <UserCheck width={20} height={20} />
                Check Eligibility
                {eligibilityCheckLoader && (
                  <span className="docpro_loading">
                    <Loader width={20} height={20} />
                  </span>
                )}
              </button>
            )}

            {can_visit('eligibility') && (
              <button className="docpro_bordered_btn docpro_fw_600"
                onClick={() => { checkBulkClaims(); }}
              >
                <MonitorCheck width={20} height={20} />
                Check Claims
                {claimsCheckLoader && (
                  <span className="docpro_loading">
                    <Loader width={20} height={20} />
                  </span>
                )}
              </button>
            )}
            
            <button 
              className="docpro_bordered_btn docpro_fw_600 docpro_primary_color"
              onClick={downloadBulkData}
              disabled = {buttonLoader ? true : false}
            >
              <CloudDownload width={20} height={20} />
              Download Selected PDF
              {buttonLoader && (
                <span className="docpro_loading">
                  <Loader width={20} height={20} />
                </span>
              )}
            </button>

            {can_visit('waiting_room') && (
              <button 
                type="button"
                className="docpro_bordered_btn docpro_fw_600 docpro_primary_color"
                onClick={() => {
                  setSendMailConfirmationModal(true);
                  setPreviousScrollPosition(window.scrollY);
                  window.scrollTo(0, 0);
                }}
              >
                <MailCheck width={20} height={20} />
                <span>Send Summary</span>
              </button>
              // <button 
              //   className="docpro_bordered_btn docpro_fw_600 docpro_primary_color"
              //   onClick={() => handleSendEmail()}
              //   disabled = {sendMailButtonLoader ? true : false}
              // >
              //   <MailCheck width={20} height={20} />
              //   <span>Send Mail</span>
              //   {sendMailButtonLoader && (
              //     <span className="docpro_loading">
              //       <Loader width={20} height={20} />
              //     </span>
              //   )}
              // </button>
            )}

            {can_visit('waiting_room') && (
              <button 
                className="docpro_bordered_btn docpro_fw_600 docpro_primary_color"
                onClick={() => handleReportNavigation()}
              >
                <Printer width={20} height={20} />
                Print Summary
              </button>
            )}

            {checkedIds?.length > 0 && (
              <div className='docpro_filtered_badge' style={{ margin: 0 }}>
                <span><b>Selected Patients</b>: {checkedIds?.length}</span>
                <button
                  onClick={removeSelection}
                >
                  ✕
                </button>
              </div>
            )}
          </div>
        </>
      )}
      <div className="docpro_table_responsive" style={{ minHeight: "450px" }}>
        <table className="docpro_mb_0" style={{ height: '100%' }}>
          <thead>
            <tr>
              <th style={{ width: "45px" }}>
                <div className="docpro_checkbox" style={{ top: "3px" }}>
                  <input
                    type="checkbox"
                    checked={tableData.length > 0 && tableData.every((row) => globalCheckedIds?.has(row?.id))}
                    onChange={handleSelectAll}
                    disabled={tableData.length === 0}
                  />
                  <label></label>
                </div>
              </th>
              {can_visit("_role_enterprise") && (
                <>
                  {/* <th 
                    onClick={() => {
                      handleOrderChange("account_name");
                    }}
                    className={orderBy === "account_name" ? "docpro_accent_color" : ""}
                  >
                    <div style={styles}>
                      Practice Name <ChevronsUpDown size={"12"} />
                    </div>
                  </th>
                  <th 
                    onClick={() => {
                      handleOrderChange("location_name");
                    }}
                    className={orderBy === "location_name" ? "docpro_accent_color" : ""}
                  >
                    <div style={styles}>
                      Location <ChevronsUpDown size={"12"} />
                    </div>
                  </th> */}
                  <th className="column_mobile_hide"> Practice Name </th>
                  <th className="column_mobile_hide"> Location </th>
                </>
              )}
              <th 
                onClick={() => {
                  handleOrderChange("dos");
                }}
                className={`column_mobile_hide ${orderBy === "dos" ? "docpro_accent_color" : ""}`}
              >
                <div style={styles}>
                DOS <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th> Last Name </th>
              <th> First Name </th>
              <th> Date of Birth </th>
              <th> Age </th>
              <th className="column_mobile_hide"> Gender </th>
              <th> Insurance Name </th>
              <th className="column_mobile_hide"> Last Visit </th>
              <th className="text-right"><span className="mr-4 pr-2">Action</span></th>
            </tr>
          </thead>
          <tbody>
            {!dataLoading ? (
              tableData.length > 0 ? (
                tableData?.map((item, index) => (
                  <tr key={index} className={`row_${item.id} ${item.status === "deleted" ? "delete_row" : ""}` }>
                    <td style={{ width: "45px" }}>
                      <div className="docpro_checkbox" style={{ top: "3px" }}>
                        <input
                          type="checkbox"
                          checked={globalCheckedIds.has(item.id)}
                          onChange={() => handleCheckboxChange(item.id, item)}
                        />
                        <label></label>
                      </div>
                    </td>
                    {can_visit("_role_enterprise") && (
                      <>
                        <td className="column_mobile_hide" onClick={() => handleViewPreVisit(item)}>
                          {item.accountName}
                        </td>
                        <td className="column_mobile_hide" onClick={() => handleViewPreVisit(item)}>
                          {item.locationName}
                        </td>
                      </>
                    )}
                    <td className="pointer column_mobile_hide" onClick={() => handleViewPreVisit(item)}>
                      {formatTo12HourDateTime(item.dos)}
                      {/* {exchangeDate(item.dos)} */}
                    </td>
                    <td className="pointer" onClick={() => handleViewPreVisit(item)}>
                      <div className="flex items-center table_img">
                        {(can_visit('ehr_veradigm')) ? (
                          <div className="relative">
                            <div className={(item.id === postVisitLoaderId && enablePostVisitLoader) 
                              ? 'docpro_no_border_avatar'
                              : ((item?.post_visit_data > 5) || postVisitCheckId?.includes(item.id))
                              ? 'docpro_border_avatar'
                              : 'docpro_no_border_avatar'
                            }>
                              <img src={item.gender === "Male" ? maleAvatar : item.gender === "Female" ? femaleAvatar : otherAvatar} className="docpro_patient_avatar" alt="User" />
                            </div>
                            {(item.id === postVisitLoaderId && enablePostVisitLoader) ? (
                              <div className="docpro_waiting_note_generating">
                                <span className="docpro_loading">
                                  <Loader width={20} height={20} color="#007bff" />
                                </span>
                              </div>
                            ) : (item?.ehr_sent_data || uploadEmrIds?.includes(item.id)) && (
                              <div className="docpro_waiting_check_mark">
                                <CircleCheck size={14} color="#007AFF" />
                              </div>
                            )}
                          </div>
                        ) : (
                          <>
                            {deviceType !== 'mobile' ? (
                              <img src={item.gender === "Male" ? maleAvatar : item.gender === "Female" ? femaleAvatar : otherAvatar} alt="User" />
                            ) : (
                              <>
                                {(item.id === postVisitLoaderId && enablePostVisitLoader) ? (
                                  <span className="docpro_loading" style={{ position: 'inherit', width: '24px', height: '24px', marginRight: '5px' }}>
                                    <LoaderCircle width={24} height={24} style={{color:"#369eff"}} />
                                  </span>
                                ) : (
                                    <>                                    
                                      {((item.post_visit_data > 5) || postVisitCheckId.includes(item.id)) ? (
                                        <span  style={{ marginRight: '4px', backgroundColor: "#74b976", borderRadius: "50%", }}>
                                          <Check width={24} height={24} style={{padding:"1px 3px", color:"#ffffff", strokeWidth: "3px"}} />
                                        </span>
                                      ) : (
                                        <img src={item.gender === "Male" ? maleAvatar : item.gender === "Female" ? femaleAvatar : otherAvatar} alt="User" />                                        
                                      )}
                                  </>
                                )} 
                              </>
                            )}
                          </>
                        )}

                        {item.lastName}
                      </div>
                    </td>
                    <td className="pointer" onClick={() => handleViewPreVisit(item)}>
                      {item.firstName}
                      {can_visit("administrator") && item?.clinical_id ? (
                        <span className="docpro_badge docpro_badge_green" style={{ padding: '0 6px', marginLeft: '3px' }}>{item?.clinical_id}</span>
                      ) : null}
                    </td>
                    <td className="pointer" onClick={() => handleViewPreVisit(item)}>
                      {exchangeDate(item.date)}
                    </td>
                    <td className="pointer" onClick={() => handleViewPreVisit(item)}>
                      {calculateAgeFromDOB(item.date)}y
                    </td>
                    <td className="pointer column_mobile_hide" onClick={() => handleViewPreVisit(item)}>
                      {item.gender}
                    </td>
                    <td className="pointer" onClick={() => handleViewPreVisit(item)}>
                      {item.insuranceName}
                      {can_visit("eligibility") && (
                        item?.is_eligible === 'Eligible' ?
                          <span className="docpro_badge docpro_badge_green" style={{ padding: '0 6px', marginLeft: '3px' }}>{item?.is_eligible}</span>
                        :
                          <span className="docpro_badge docpro_badge_red" style={{ padding: '0 6px', marginLeft: '3px' }}>{item?.is_eligible}</span>
                      )}
                    </td>
                    <td className="pointer column_mobile_hide" onClick={() => handleViewPreVisit(item)}>
                      {exchangeDate(item.lastVisit)}
                    </td>

                    <td className="docpro_text_center">
                      <div className="docpro_icon_btns items-center" style={{ justifyContent: 'end' }}>
                        {showPrevisitLoaderData?.pending_ids?.includes(item.id) && (
                          <span className="docpro_badge docpro_badge_orange">Generating</span>
                        )}
                        {item.status === "deleted" ? (
                          <button
                            type="button"
                            style={{ width: '38px', borderRadius:'7px' }}
                            className="docpro_icon_btn docpro_dropdown_button"
                            onClick={() => handleDelete(item)}
                          >
                            <Trash2 width={18} height={18} />
                          </button>
                        ) : (
                          <>
                            {(() => {
                              const visibleButtons = buttonArray
                                .map((btn, idx) => ({ ...btn, _idx: idx }))
                                .filter(({ _idx }) => {
                                  const hasPermission = permissions[`showButton${_idx + 1}`];
                                  if (_idx === 0 || _idx === 1) return hasPermission && !!item.insurance_code;
                                  return hasPermission;
                                });

                              const mainButtons = visibleButtons.slice(0, 3);
                              const collapsedButtons = visibleButtons.slice(3);
                              const highlightIndex = item.insurance_code ? 2 : 0;

                              return (
                                <>
                                  {mainButtons.map((btn, i) => (
                                    <div key={`${btn.label}-main-${i}`}>
                                      {btn.isButton ? (
                                        <button type="button"
                                          className={`docpro_icon_btn last_btn_tip ${item.isPrint && i === highlightIndex ? 'docpro_vivid_color' : ''} ${isRed && item.id === isRedId && i === highlightIndex ? 'docpro_vivid_color' : ''}`}
                                          onClick={() => btn.action(item)}
                                        >
                                          <btn.icon width={18} height={18} />
                                          <span className="docpro_tip">{btn.label}</span>
                                        </button>
                                      ) : (
                                        <Link to={`${btn.action}?patient_id=${item.patient_id}`}>
                                          <button type="button" className="docpro_icon_btn last_btn_tip">
                                            <btn.icon width={18} height={18} />
                                            <span className="docpro_tip">{btn.label}</span>
                                          </button>
                                        </Link>
                                      )}
                                    </div>
                                  ))}
                                  {collapsedButtons.length > 0 && (
                                    <div className="dropdown-container relative">
                                      <button className="docpro_icon_btn" onClick={() => handleDropdownClick(index)}>
                                        <EllipsisVertical width={18} height={18} />
                                      </button>

                                      {viewStatusOptions[index] && (
                                        <div className={`docpro_button_toggle_options ${index > 4 && 'top_position'}`}>
                                          {collapsedButtons.map((btn, i) => (
                                            <div key={`${btn.label}-dd-${i}`}>
                                              {btn.isButton ? (
                                                <button type="button"
                                                  className="docpro_icon_btn docpro_dropdown_button"
                                                  onClick={() => btn.action(item)}
                                                >
                                                  <btn.icon width={18} height={18} />
                                                  <span>{btn.label}</span>
                                                </button>
                                              ) : (
                                                <Link to={`${btn.action}?patient_id=${item.patient_id}`}>
                                                  <button type="button" className="docpro_icon_btn docpro_dropdown_button">
                                                    <btn.icon width={18} height={18} />
                                                    <span>{btn.label}</span>
                                                  </button>
                                                </Link>
                                              )}
                                            </div>
                                          ))}
                                        </div>
                                      )}
                                    </div>
                                  )}
                                </>
                                );
                            })()}
                          </>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="no_data docpro_p_0" style={{ height: "450px" }} colSpan={`${can_visit("_role_enterprise") ? 12 : 10}`}>
                    No data available
                  </td>
                </tr>
              )
            ) : (
              Array.from({ length: 8 }).map((_, index) => (
                <tr key={index} style={{ height: '50px' }}>
                  <td style={{ width: "45px" }}> <Skeleton width="1.2rem" borderRadius="8px"></Skeleton> </td>
                  {can_visit("_role_enterprise") && (
                    <>
                      <td className="column_mobile_hide"> <Skeleton width={`${3 + (index % 2)}rem`} borderRadius="8px"></Skeleton> </td>
                      <td className="column_mobile_hide"> <Skeleton width={`${4 + (index % 1.2)}rem`} borderRadius="8px"></Skeleton> </td>
                    </>
                  )}
                  <td className="column_mobile_hide"> <Skeleton width="5rem" borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${4 + (index % 3)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${5 + (index % 3.2)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width="5rem" borderRadius="8px"></Skeleton> </td>
                  <td className="column_mobile_hide"> <Skeleton width={`${3 + (index % 1.5)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${5 + (index % 3)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${5 + (index % 3)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td className="column_mobile_hide"> <Skeleton width="5rem" borderRadius="8px"></Skeleton> </td>
                  <td className="text-right"> <span className="mr-4 pr-2"><Skeleton width="3rem" borderRadius="8px"></Skeleton></span> </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      {activeModal && (
        <ReviewMessageModal
          onClose={onCloseModal}
          patientData={selectedItem}
          handleSendReview={handleSendReviewRequest}
        />
      )}

      {activeDeleteModal && (
        <DeleteModal
          handleDelete={() => handleDeleteRecord(deleteRecord?.id)}
          name={deleteRecord?.last_name + ' ' + deleteRecord?.first_name}
          activeModal={activeDeleteModal}
          setActiveModal={setActiveDeleteModal}
          previousScrollPosition={previousScrollPosition}
          setPreviousScrollPosition={setPreviousScrollPosition}
        />
      )}
      
      {activeMessageModal && (
        <MessageModal
          patient_id={patientData.patientId}
          last_name={patientData.lastName}
          first_name={patientData.firstName}
          phone={patientData.mobilePhone}
          messageTemplate={messageTemplate}
          tooltip={true}
          account_id={account_id}
          location_id={location_id}
          activeModal={activeMessageModal}
          setActiveModal={setActiveMessageModal}
          setSmsLimit={setSmsLimit}
          previousScrollPosition={previousScrollPosition}
        />
      )}

      {activeLetterModal && (
        <LetterModal
          last_name={patientData.lastName}
          first_name={patientData.firstName}
          address={patientData.address}
          messageTemplate={messageTemplate}
          account_id={account_id}
          location_id={location_id}
          activeModal={activeLetterModal}
          setActiveModal={setactiveLetterModal}
          setLetterLimit={setLetterLimit}
          previousScrollPosition={previousScrollPosition}
        />
      )}

      {activeCreateOrderModal && (
        <CreateOrderModal
          last_name={patientData.lastName}
          first_name={patientData.firstName}
          phone={patientData.mobilePhone}
          patient_id = {patientData.patientId}
          insurance_name = {patientData.insuranceName}
          insurance_code = { patientData.insurance_code}
          zip_code = { patientData.zip_code}
          user_id={user_id}
          account_id={account_id}
          location_id={location_id}
          activeModal={activeCreateOrderModal}
          setActiveModal={setActiveOrderModal}
          setSmsLimit={setSmsLimit}
          previousScrollPosition={previousScrollPosition}
        />
      )}
      
      {activePatientViewModal && (
        <PatientSingleViewModal
          practice_id={patientData.locationId}
          patient_id={patientData.patientId}
          reloadData={reloadData}
          reloadDataFilter={reloadDataFilter}
          messageTemplate={messageTemplate}
          account_id={account_id}
          location_id={location_id}
          insuranceOptions={insuranceOptions}
          activeModal={activePatientViewModal}
          setActiveModal={setActivePatientViewModal}
          setSmsLimit={setSmsLimit}
          outreachOpen={outreachOpen}
          setOutreachOpen={setOutreachOpen}
          startSchedular={startSchedular}
          setStartSchedular={setStartSchedular}
          callNoteCallType={callNoteCallType}
          setCallNoteCallType={setCallNoteCallType}
          setActiveCallNoteCallModal={setActiveCallNoteCallModal}
          callId={callId}
          previousScrollPosition={previousScrollPosition}
          setPreviousCallScrollPosition={setPreviousCallScrollPosition}
        />
      )}

      {sendMailConfirmationModal && (
        <OtpConfirmationModal
          actionType={handleSendEmail}
          openModal={sendMailConfirmationModal}
          setOpenModal={setSendMailConfirmationModal}
          enableOtpConfirmationLoader={sendMailButtonLoader}
          sendFrom="waiting"
          previousScrollPosition={previousScrollPosition}
        />
      )}

      {activeCallNoteModal && (
        <CallNoteModal
          patient_data={patientData} 
          activeModal={activeCallNoteModal}
          setActiveModal={setActiveCallNoteModal}
          setCallNoteCallType={setCallNoteCallType}
          setActiveCallNoteCallModal={setActiveCallNoteCallModal}
          previousScrollPosition={previousScrollPosition}
          setPreviousCallScrollPosition={setPreviousCallScrollPosition}
        />
      )}

      {activeCallNoteCallModal && (
        <CallNoteCallModal
          account_id={account_id}
          location_id={location_id}
          patient_data={patientData}
          callNoteCallType={callNoteCallType}
          activeModal={activeCallNoteCallModal}
          setActiveModal={setActiveCallNoteCallModal}
          setOutreachOpen={setOutreachOpen}
          setActivePatientViewModal={setActivePatientViewModal}
          startSchedular={startSchedular}
          setStartSchedular={setStartSchedular}
          smsLimit={smsLimit}
          setCallId={setCallId}
          callFrom={"waiting"}
          previousCallScrollPosition={previousCallScrollPosition}
        />
      )}

      {previsitViewStatus && (
        <AuditReportViewModal
          account_id={account_id}
          location_id={location_id}
          specility_id={specilityId}
          waiting_room_id={viewPreVisitcallId}
          active_modal={previsitViewStatus}
          set_active_modal={setPrevisitViewStatus}
          setCallNoteCallType={setCallNoteCallType}
          setActiveCallNoteCallModal={setActiveCallNoteCallModal}
          handleSignOutSheet={handleSignOutSheet}
          waitingId={patientData?.id}
          previousScrollPosition={previousScrollPosition}
          setPreviousScrollPosition={setPreviousScrollPosition}
          previousCallScrollPosition={previousCallScrollPosition}
          setPreviousCallScrollPosition={setPreviousCallScrollPosition}
          setPostVisitLoaderId={setPostVisitLoaderId}
          setEnablePostVisitLoader={setEnablePostVisitLoader}
          setPostVisitUploadEmrId={setPostVisitUploadEmrId}
        />
      )}

      {activeEligibilityViewModal && (
        <EligibilitySingleViewModal
          patient_data={patientData}
          activeModal={activeEligibilityViewModal}
          setActiveModal={setActiveEligibilityViewModal}
          previousScrollPosition={previousScrollPosition}
          checkEligibilityFromWaiting={true}
        />
      )}

      {activeClaimViewModal && (
        <ClaimSingleViewModal
          patient_data={patientData}
          activeModal={activeClaimViewModal}
          setActiveModal={setActiveClaimViewModal}
          previousScrollPosition={previousScrollPosition}
        />
      )}
    </>
  );
}
